import React from 'react';

export default function BillingList() {
  return <h1>Billing</h1>;
}
